import { ca } from '@cian/analytics';

import { LANDING_EVENT_CATEGORY, LANDING_PAGE_TYPE, OLD_EVENT_NAME } from 'shared/constants/tracking';

interface ILandingEventParams {
  action: string;
  label?: string;
  extra?: Record<string, unknown>;
}

export type TLandingEvent = (userId?: number, runtimeExtra?: Record<string, unknown>) => void;

export const createLandingEvent = ({ extra, ...params }: ILandingEventParams): TLandingEvent => {
  return (userId?: number, runtimeExtra?: Record<string, unknown>): void => {
    ca('eventSite', {
      name: OLD_EVENT_NAME,
      category: LANDING_EVENT_CATEGORY,
      ...params,
      page: createEventPage(extra, runtimeExtra),
      user: getAnalyticsUser(userId),
    });
  };
};

function createEventPage(
  extra?: Record<string, unknown>,
  runtimeExtra?: Record<string, unknown>,
): { pageType: string; extra?: Record<string, unknown> } {
  const pageExtra = {
    ...extra,
    ...runtimeExtra,
  };

  if (Object.keys(pageExtra).length === 0) {
    return { pageType: LANDING_PAGE_TYPE };
  }

  return { pageType: LANDING_PAGE_TYPE, extra: pageExtra };
}

function getAnalyticsUser(userId?: number): Record<string, unknown> {
  if (!userId || !Number.isFinite(userId)) {
    return {};
  }

  return { userId };
}

/** Клик по CTA-кнопке лендинга */
export const caButtonClick = createLandingEvent({
  action: 'click',
  label: 'button',
});

/** Показ модалки «Спасибо, что вы с нами!» */
export const caBannerShow = createLandingEvent({
  action: 'show',
  label: 'banner',
});

/** Закрытие модалки «Спасибо, что вы с нами!» */
export const caBannerClose = createLandingEvent({
  action: 'close',
  label: 'banner',
});

/** Клик по кнопке «В личный кабинет» в модалке */
export const caBannerClick = createLandingEvent({
  action: 'click',
  label: 'banner',
});
